// extracted by mini-css-extract-plugin
export default {"Content":"PaymentAwaiting_Content__H8QH9","Title":"PaymentAwaiting_Title__ZFiGj","Subtitle":"PaymentAwaiting_Subtitle__QRX5T"};